import {createBrowserRouter, Navigate, RouterProvider,} from "react-router-dom";
import App from "./App";
import ActivateSmartwatch from "./pages/activate-smartwatch";
import EmergencyAddress from "./pages/emergency-address";
import TermsAndConditions from "./pages/terms-and-conditions";
import Confirmation from "./pages/confirmation";
import RegisterNewAddress from "./pages/register-new-address";
import Workaround from "./pages/workaround";
import ReplaceWarning from "./pages/replace-warning";
import GenericError from "./pages/generic-error";

export const Providers: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <App></App>,
        children: [
          {
            path: "",
            index: true,
            element: <Navigate to="/workaround" replace />,
          },
          {
            path: "activate-smartwatch",
            element: <ActivateSmartwatch></ActivateSmartwatch>,
          },
          {
            path: "emergency-address",
            index: false,
            element: <EmergencyAddress></EmergencyAddress>,
          },
          {
            path: "register-address",
            index: false,
            element: <RegisterNewAddress></RegisterNewAddress>,
          },
          {
            path: "terms-and-conditions",
            index: false,
            element: <TermsAndConditions></TermsAndConditions>,
          },
          {
            path: "confirmation",
            index: false,
            element: <Confirmation></Confirmation>,
          },
            {
                path: "workaround",
                index: false,
                element: <Workaround></Workaround>,
            },
          {
            path: "replace",
            index: false,
            element: <ReplaceWarning></ReplaceWarning>,
          },
          {
            path: "error",
            index: false,
            element: <GenericError></GenericError>,
          },
        ],
      },
    ],
    { basename: "" },
  );
  return <RouterProvider router={router}></RouterProvider>;
};
